// Recovered compiled webpack factory 28385. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  let n;
  r.d(t, { $X: () => u, GR: () => d, M6: () => f, eJ: () => s, gO: () => c });
  var a = r(73314),
    o = r(78714),
    i = r(49636);
  function s(
    e = (function () {
      let e = i.O;
      return e.crypto || e.msCrypto;
    })(),
  ) {
    try {
      if (e?.randomUUID) return (0, o.Qw)(() => e.randomUUID()).replace(/-/g, "");
    } catch {}
    return (
      n || (n = "10000000100040008000100000000000"),
      n.replace(/[018]/g, (e) => (e ^ ((15 & (16 * (0, o.hY)())) >> (e / 4))).toString(16))
    );
  }
  function l(e) {
    return e.exception?.values?.[0];
  }
  function u(e) {
    let { message: t, event_id: r } = e;
    if (t) return t;
    let n = l(e);
    return n
      ? n.type && n.value
        ? `${n.type}: ${n.value}`
        : n.type || n.value || r || "<unknown>"
      : r || "<unknown>";
  }
  function c(e, t, r) {
    let n = (e.exception = e.exception || {}),
      a = (n.values = n.values || []),
      o = (a[0] = a[0] || {});
    (o.value || (o.value = t || ""), o.type || (o.type = r || "Error"));
  }
  function f(e, t) {
    let r = l(e);
    if (!r) return;
    let n = r.mechanism;
    if (((r.mechanism = { type: "generic", handled: !0, ...n, ...t }), t && "data" in t)) {
      let e = { ...n?.data, ...t.data };
      r.mechanism.data = e;
    }
  }
  function d(e) {
    if (
      (function (e) {
        try {
          return e.__sentry_captured__;
        } catch {}
      })(e)
    )
      return !0;
    try {
      (0, a.my)(e, "__sentry_captured__", !0);
    } catch {}
    return !1;
  }
}
